import { HTMLProps } from 'react';
import { CheckboxCircleEmpty } from '../icons/CheckboxCircleEmpty';
import { CheckboxCircleSelected } from '../icons/CheckboxCircleSelected';
import './LineSelector.css';

export function LineSelector({
  defaultSelected,
  children,
  className,
  onClick,
  checked,
  disabled,
  ...props
}: HTMLProps<HTMLDivElement> & {
  defaultSelected?: boolean;
}) {
  return (
    <div
      {...props}
      className={`LineSelector ${checked ? 'Active' : ''} ${disabled ? 'Disabled' : ''} ${className}`}
      onClick={(e) => {
        if (onClick && !disabled) onClick(e);
      }}
    >
      <div className={`LineSelectorContent`}>{children}</div>

      <div className={`LineSelectorCheckMarkContainer ${disabled ? 'Disabled' : ''}`}>
        {checked ? <CheckboxCircleSelected /> : <CheckboxCircleEmpty />}
      </div>
    </div>
  );
}
